import { Component, Input } from '@angular/core';

/**
 * Generated class for the MenuComponent component.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/ComponentMetadata-class.html
 * for more info on Angular Components.
 */
@Component({
  selector: 'menu',
  templateUrl: 'menu.html'
})
export class MenuComponent {

  text: string;
  @Input() index: Number;
  @Input() menuId: Number;
  @Input() menuName: String;
  @Input() especialPrice: number;
  @Input() formattedPrice: string;
  @Input() excludeTaxPrice: Number;
  @Input() menuImageUri: String;
  @Input() menuLockImageUri: String;

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/pages/menulist/menu/menu.ts